import * as Yup from 'yup';
// import PropTypes from 'prop-types';
import { useCallback, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton, MobileDatePicker } from '@material-ui/lab';
import { useTheme } from '@material-ui/core/styles';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  Link,
  FormHelperText,
  FormControlLabel,
  Button,
  Container,
  Autocomplete,
  IconButton,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Chip,
  Radio,
  RadioGroup,
  FormControl,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent
} from '@material-ui/core';

// utils
import { fData } from '../../../utils/formatNumber';
import fakeRequest from '../../../utils/fakeRequest';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';
import Page from 'src/components/Page.js';
//
import Label from '../../Label';
import { UploadAvatar, UploadSingleFile } from '../../upload';
import { Link as RouterLink } from 'react-router-dom';
import countries from '../user/countries';
import moment from 'moment';
import axios from 'axios';
import {REST_API_END_POINT} from '../../../constants/Defaultvalues';
import { Delete, KeyboardBackspaceOutlined, QrCodeScanner, Close } from '@material-ui/icons';
import Scrollbar from 'src/components/Scrollbar';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png';
import { Html5QrcodeScanner } from 'html5-qrcode';

const VALUE = [
  { id: 0, value: 'Material ID' },
  { id: 1, value: 'Materials' },
  { id: 2, value: 'Unit Cost' },
  { id: 3, value: 'Stock' },
  { id: 4, value: 'Min value' },
  { id: 5, value: 'Max Value' },
  { id: 6, value: 'Quantity' },
  // { id: 9, value: 'Shipping Per Item' },
  { id: 7, value: 'Sub total' },
  { id: 8, value: '' }
]
const VALUEStockCatalog = [
  { id: 0, value: 'Catalog ID' },
  { id: 1, value: 'Catalogs' },
  { id: 2, value: 'Unit Cost' },
  { id: 3, value: 'Stock' },
  { id: 6, value: 'Quantity' },
  // { id: 9, value: 'Shipping Per Item' },
  { id: 7, value: 'Sub total' },
  { id: 8, value: '' }
]

export default function CreateReceiveOrders() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme()
  const [vendors, setVendors] = useState([]);
  const [productsData, setProductsData] = useState([]);
  console.log('productsData....',productsData)
  const [serviceData, setServiceData] = useState([]);
  const [productsDatafilter, setProductsDatafilter] = useState([]);
  const currentDate = moment().format('MM-DD-YYYY');
  const [dataSetValue,setDataSetvalue] = useState({minVal:'',maxVal:''})
  const userData = JSON.parse(localStorage.getItem('user'))
  const userId = userData.user_id
  const userType = userData.user_type
  const [productRows, setProductRows] = useState([{ product: '', qty: '', unitCost: '', total: '' }]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [taxPercentage, setTaxPercentage] = useState(0);
  const [selectedTaxCategory,setSelectedTaxCategory]=  useState(null);
  const [taxCategories,setTaxCategories]=  useState([]);
 const [taxValue,setTaxValue] = useState(null)
 const [stockCatalogs,setStockCatalogs] = useState([])
 const [selectedStockCatalog,setSelectedStockCatalog] = useState([])
 const [selectedServices, setSelectedServices] = useState([])
 const [productType,setProductType] = useState('materials')
 const [renderService,setRenderService] = useState(false)
 const [openQRScanner, setOpenQRScanner] = useState(false);
 const [openCatalogQRScanner, setOpenCatalogQRScanner] = useState(false);
 const scannerRef = useRef(null);
 const catalogScannerRef = useRef(null);
 const [searchMaterial, setSearchMaterial] = useState('');
 const [qrSearchDisplayName, setQrSearchDisplayName] = useState('');
 const [searchCatalog, setSearchCatalog] = useState('');
 const [qrCatalogSearchDisplayName, setQrCatalogSearchDisplayName] = useState('');

  let totalAmount = 0;


  const fetchTaxCategory = async () => {
    try{
        const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
        if(response.data.status === 1){
            setTaxCategories(response.data.taxResult);
        }else{
          setTaxCategories([])
        }
    }catch(error){
        console.log("Error - ",error);
        setTaxCategories([])
    }
  }
  
  const handleback = () => {
    window.history.back()
  }
  const handleAddRow = () => {
    setProductRows([...productRows, { product: '', qty: '', unitCost: '', total: '' }]);
  };

  const handleDeleteRow = (id) => {
    setProductRows(productRows.filter((row,index) => index !== id));
  };

  // const handleProduct = (value) => {
  //   const productsWithQuantity = value.map((product) => ({
  //     ...product,
  //     quantity: selectedProducts.filter((p) => p.id === product.id)[0]?.quantity || 0,
  //     unitCost: selectedProducts.filter((p) => p.id === product.id)[0]?.unitCost || 0,     
  //   }));
  //   // console.log('productsWithQuantity*****',productsWithQuantity);
  //   setSelectedProducts(productsWithQuantity);
  // };

  const handleProduct = async (value) => {
    const productsWithQuantity = await Promise.all(value.map(async (product) => {
      const existing = selectedProducts.find((p) => p.id === product.id);
      
      // If vendor is selected and material doesn't have existing unitCost, fetch last unit cost
      let unitCost = existing?.unitCost || 0;
      if (values.vendor && !existing?.unitCost) {
        try {
          const response = await axios.post(
            `${REST_API_END_POINT}product/get-last-vendor-material-unit-cost`,
            {
              vendor_id: values.vendor,
              material_id: product.id
            }
          );
          if (response.data.status === 1 && response.data.unit_cost) {
            unitCost = response.data.unit_cost;
          }
        } catch (error) {
          console.error('Error fetching last unit cost:', error);
          // Keep unitCost as 0 if fetch fails
        }
      }
      
      return {
        ...product,
        quantity: existing?.quantity || 0,
        unitCost: unitCost,
        shipping_cost: existing?.shipping_cost || 0,
        services: existing?.services || null
      };
    }));
    setSelectedProducts(productsWithQuantity);
  };

  const handleStockCatalog = async (value) => {
    const stockCatalogsWithQuantity = await Promise.all(value.map(async (stockCatalog) => {
      const existing = selectedStockCatalog.find((p) => p.id === stockCatalog.id);
      
      // If vendor is selected and catalog doesn't have existing unitCost, fetch last unit cost
      let unitCost = existing?.unitCost || 0;
      if (values.vendor && !existing?.unitCost) {
        try {
          const response = await axios.post(
            `${REST_API_END_POINT}product/get-last-vendor-material-unit-cost`,
            {
              vendor_id: values.vendor,
              material_id: stockCatalog.id
            }
          );
          if (response.data.status === 1 && response.data.unit_cost) {
            unitCost = response.data.unit_cost;
          }
        } catch (error) {
          console.error('Error fetching last unit cost:', error);
          // Keep unitCost as 0 if fetch fails
        }
      }
      
      return {
        ...stockCatalog,
        quantity: existing?.quantity || 0,
        unitCost: unitCost,
        shipping_cost: existing?.shipping_cost || 0,
        services: existing?.services || null
      };
    }));
    setSelectedStockCatalog(stockCatalogsWithQuantity);
  };

  const handleService = (value) => {
    const servicesWithPrice = value.map((service) => {
      const existing = selectedServices.find((s) => s.id === service.id);
      return {
        ...service,
        total_cost: existing?.total_cost || service.total_cost || 0
      };
    });
    setSelectedServices(servicesWithPrice);
    
    // Calculate sub_total
    let newTotalAmount = 0;
    servicesWithPrice.forEach(service => {
      newTotalAmount += parseFloat(service?.total_cost || 0);
    });
    const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
    setFieldValue('sub_total', Number(fixedTotal));
  };


  const calculateTotal = (price, quantity) => {
    const parsedPrice = parseFloat(price) || 0;
    const parsedQuantity = parseFloat(quantity) || 0;
    const subtotal = parsedPrice * parsedQuantity;
    return parseFloat(subtotal.toFixed(2));;
  };
  const calculateGrandTotal = (subtotal) => {
  const includeTax = values.includeTax === 1;
  // let taxAmount = 0;
  const taxAmount = selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (subtotal * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
  // if (includeTax) {
  //   taxAmount = subtotal * taxPercentage / 100;
  // }
  return subtotal + taxAmount;
};

  const handleDeleteProduct = (productId,type) => {
    const isMaterial = type == 1;
    if (isMaterial) {
      const filteredProduct = selectedProducts.filter(data => data.id !== productId);
      setFieldValue('products', filteredProduct);
      setSelectedProducts(filteredProduct);
      
      let newTotalAmount = 0;
      filteredProduct.forEach(product => {
        const subtotal = (
          (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
          (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
          parseFloat(product?.services?.total_cost || 0)
        );
        newTotalAmount += subtotal;
      });
      let fixedAmount = parseFloat(newTotalAmount).toFixed(2);
      setFieldValue('sub_total', Number(fixedAmount));
      setFieldValue('grand_total', calculateGrandTotal(fixedAmount));
    } else if (type == 0) {
      const filteredCatalog = selectedStockCatalog.filter(data => data.id !== productId);
      setFieldValue('stockCatalogs', filteredCatalog);
      setSelectedStockCatalog(filteredCatalog);
      
      let newTotalAmount = 0;
      filteredCatalog.forEach(catalog => {
        const subtotal = (
          (parseFloat(catalog?.unitCost || 0) * parseFloat(catalog?.quantity || 0)) +
          (parseFloat(catalog?.shipping_cost || 0) * parseFloat(catalog?.quantity || 0)) +
          parseFloat(catalog?.services?.total_cost || 0)
        );
        newTotalAmount += subtotal;
      });
      let fixedAmount = parseFloat(newTotalAmount).toFixed(2);
      setFieldValue('sub_total', Number(fixedAmount));
      setFieldValue('grand_total', calculateGrandTotal(fixedAmount));
    } else if (type == 2) {
      // Service deletion
      const filteredServices = selectedServices.filter(data => data.id !== productId);
      setFieldValue('services', filteredServices);
      setSelectedServices(filteredServices);
      
      let newTotalAmount = 0;
      filteredServices.forEach(service => {
        newTotalAmount += parseFloat(service?.total_cost || 0);
      });
      let fixedAmount = parseFloat(newTotalAmount).toFixed(2);
      setFieldValue('sub_total', Number(fixedAmount));
      setFieldValue('grand_total', calculateGrandTotal(fixedAmount));
    }
  };

  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    color: theme.palette.text.primary,
  }))
  
  const fetchVendors = async () => {
    try{
      const response = await axios.post(`${REST_API_END_POINT}clients/getAllClients`,{userId,userType,
        isVendor:1
      })
      if(response.data.status === 1){
        const vendors = response?.data?.customer;
        setVendors(vendors);
      }
    }
    catch(error){
      console.log("Error - ",error);
    }
  }
  // const fetchTaxCategory = async () => {
  //   try{
  //     const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
  //     if(response.data.status === 1){
  //       const tax = response.data.taxResult?.find((option) => option.name = 'tax')
  //       if(tax){
  //         setTaxPercentage(tax.value);
  //       }
  //       else{
  //         setTaxPercentage(0);
  //       }
  //     }
  //   }
  //   catch(error){
  //     console.log("Error - ",error);
  //   }
  // }
  const fetchProducts = async () => {
    try{
      const response = await axios.post(`${REST_API_END_POINT}product/get-all-materials`,{userId,userType,
        isVendor:1,bringStockCatalog:1})
      if(response.data.status === 1){
        // setProductsData(response.data.results);
        setProductsDatafilter(response.data.results);
        setServiceData(response?.data?.allServices)
        setStockCatalogs(response?.data?.stockCatalogs)
      }
    }
    catch(error){
      console.log("Error - ",error);
    }
  }

  useEffect(()=>{
    fetchVendors();
    fetchTaxCategory()
    fetchProducts()
  },[])


  const NewProductSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    vendor: Yup.string().required('Vendor name is required'),
    receivedDate: Yup.date(),
    expectedDate: Yup.date(),
    // transactionId: Yup.string().required('Transaction ID is required'),
    products:productType =="materials" && Yup.array().min(1,'Please select atleast one product'),
    stockCatalogs:productType =="stockCatalog" && Yup.array().min(1,'Please select atleast one catalog'),
    services:productType =="serviceOnly" && Yup.array().min(1,'Please select atleast one service'),
  });
  
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  }));
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
      vendor:'',
      transactionId:'',
      receivedDate:moment().format('YYYY-MM-DD'),
      expectedDate:moment().format('YYYY-MM-DD'),
      includeTax:0,
      products: [],
      tax: 0,
      sub_total:0,
      grand_total:0,
      taxCategory:null,
      stockCatalogs:[],
      services: [],
      orderType: 'materials'
    },
    validationSchema: NewProductSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors, setFieldError }) => {
      try {
        // console.log('selectedProducts---',selectedProducts);
        values.taxCategory= selectedTaxCategory?.id
        const hasErrors = selectedProducts.some(product => product.unitCost === 0 || product.quantity === 0 || !product.unitCost || !product.quantity);
        const hasErrorsInCatalog = selectedStockCatalog.some(product => product.unitCost === 0 || product.quantity === 0 || !product.unitCost || !product.quantity);
        const hasErrorsInServices = selectedServices.some(service => !service.total_cost || service.total_cost === 0 || parseFloat(service.total_cost) <= 0);
        if(hasErrors){
          enqueueSnackbar('Please enter valid Unit Cost and  Quantity for material', { variant: 'error' });
        }else if(hasErrorsInCatalog){
          enqueueSnackbar('Please enter valid Unit Cost and  Quantity for catalog', { variant: 'error' });
        }else if(hasErrorsInServices){
          enqueueSnackbar('Please enter valid price for all services', { variant: 'error' });
        }else{
          values.products = selectedProducts
          values.stockCatalogs = selectedStockCatalog
          values.services = selectedServices
          const response = await axios.post(`${REST_API_END_POINT}product/create-receive-order`,{values,userId,})
          if (response.data.status === 1) {
            enqueueSnackbar(`Order ${values['name']} created successfully`, { variant: 'success' });
          }
          else {
            enqueueSnackbar('Failed to create order', { variant: 'error' });
          }
          resetForm();
          setSubmitting(false);
          navigate(PATH_DASHBOARD.receiveOrder.root);
        }
      } catch (error) {
        console.error("Error : ", error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;

  const handleSearchMaterialByQR = useCallback(async (materialBarcode) => {
    try {
      if (!materialBarcode) return;

      const response = await axios.post(`${REST_API_END_POINT}product/search-finished-product-by-qr`, {
        barcode: materialBarcode,
        userId,
        userType,
        isMaterial: true
      });

      if (response.data.status === 1) {
        const productListData = response.data.results;
        if (productListData && productListData.length > 0) {
          // Get current formik values to avoid stale closure
          const currentValues = formik.values;
          
          // Filter products that match the vendor and are inhouse
          const filteredProducts = productListData.filter(product => {
            if (!currentValues.vendor) return true;
            const vendorIds = product?.vendor_id?.split(',').map(id => id.trim());
            return vendorIds?.includes(currentValues.vendor?.toString()) && product.inhouse == 1;
          });

          if (filteredProducts.length > 0) {
            // Auto-select the first matching material
            const materialToAdd = filteredProducts[0];
            const isAlreadySelected = selectedProducts.some(p => p.id === materialToAdd.id);
            
            if (!isAlreadySelected) {
              const newProducts = [...currentValues.products, materialToAdd];
              setFieldValue('products', newProducts);
              handleProduct(newProducts);
            }
            
            setQrSearchDisplayName(materialBarcode || '');
            enqueueSnackbar('Material found and added', { variant: 'success' });
          } else {
            enqueueSnackbar('Material not found for selected vendor', { variant: 'warning' });
          }
        } else {
          enqueueSnackbar('Material not found', { variant: 'warning' });
        }
      } else {
        enqueueSnackbar('Material not found', { variant: 'warning' });
      }
    } catch (error) {
      console.error("Error searching material by QR:", error);
      enqueueSnackbar('Error searching material', { variant: 'error' });
    }
  }, [formik, selectedProducts, setFieldValue, handleProduct, userId, userType, enqueueSnackbar]);

  useEffect(() => {
    if (openQRScanner) {
      setTimeout(() => {
        if (!scannerRef.current) {
          scannerRef.current = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });

          scannerRef.current.render(
            (decodedText) => {
              setSearchMaterial(decodedText);
              handleSearchMaterialByQR(decodedText);
              setOpenQRScanner(false);
            },
            (errorMessage) => {
              console.error("QR Scan Error:", errorMessage);
            }
          );
        }
      }, 500);
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear();
        scannerRef.current = null;
      }
    };
  }, [openQRScanner, handleSearchMaterialByQR]);

  const handleSearchCatalogByQR = useCallback(async (catalogBarcode) => {
    try {
      if (!catalogBarcode) return;

      const response = await axios.post(`${REST_API_END_POINT}product/search-finished-product-by-qr`, {
        barcode: catalogBarcode,
        userId,
        userType,
        isMaterial: false
      });

      if (response.data.status === 1) {
        const catalogListData = response.data.results;
        if (catalogListData && catalogListData.length > 0) {
          // Get current formik values to avoid stale closure
          const currentValues = formik.values;
          
          // Filter catalogs that match the vendor
          const filteredCatalogs = catalogListData.filter(catalog => {
            if (!currentValues.vendor) return true;
            const vendorIds = catalog?.vendor_id?.split(',').map(id => id.trim());
            return vendorIds?.includes(currentValues.vendor?.toString());
          });

          if (filteredCatalogs.length > 0) {
            // Auto-select the first matching catalog
            const catalogToAdd = filteredCatalogs[0];
            const isAlreadySelected = selectedStockCatalog.some(c => c.id === catalogToAdd.id);
            
            if (!isAlreadySelected) {
              const newCatalogs = [...currentValues.stockCatalogs, catalogToAdd];
              setFieldValue('stockCatalogs', newCatalogs);
              handleStockCatalog(newCatalogs);
            }
            
            setQrCatalogSearchDisplayName(catalogBarcode || '');
            enqueueSnackbar('Catalog found and added', { variant: 'success' });
          } else {
            enqueueSnackbar('Catalog not found for selected vendor', { variant: 'warning' });
          }
        } else {
          enqueueSnackbar('Catalog not found', { variant: 'warning' });
        }
      } else {
        enqueueSnackbar('Catalog not found', { variant: 'warning' });
      }
    } catch (error) {
      console.error("Error searching catalog by QR:", error);
      enqueueSnackbar('Error searching catalog', { variant: 'error' });
    }
  }, [formik, selectedStockCatalog, setFieldValue, handleStockCatalog, userId, userType, enqueueSnackbar]);

  useEffect(() => {
    if (openCatalogQRScanner) {
      setTimeout(() => {
        if (!catalogScannerRef.current) {
          catalogScannerRef.current = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });

          catalogScannerRef.current.render(
            (decodedText) => {
              setSearchCatalog(decodedText);
              handleSearchCatalogByQR(decodedText);
              setOpenCatalogQRScanner(false);
            },
            (errorMessage) => {
              console.error("QR Scan Error:", errorMessage);
            }
          );
        }
      }, 500);
    }

    return () => {
      if (catalogScannerRef.current) {
        catalogScannerRef.current.clear();
        catalogScannerRef.current = null;
      }
    };
  }, [openCatalogQRScanner, handleSearchCatalogByQR]);

  const updateGrandTotal = () => {
    const subtotal = values.sub_total || 0;
    // const grandTotal = calculateGrandTotal(subtotal);
    // const grandTotal = parseFloat(calculateGrandTotal(subtotal).toFixed(2));
    const taxAmount = selectedTaxCategory 
    ? (selectedTaxCategory.type === 1 
        ? (values.sub_total * (selectedTaxCategory.value || 0) / 100) 
        : (selectedTaxCategory.value || 0)) 
    : 0;

const fixedTaxAmount = parseFloat(taxAmount).toFixed(2);

const subTotal = parseFloat(values.sub_total || 0).toFixed(2);
// const grandTotal = Number(subTotal) + Number(fixedTaxAmount);
const grandTotal = (Number(subTotal) + Number(fixedTaxAmount)).toFixed(2);
console.log('grandTotal 1-------------------',grandTotal)
console.log('grandTotal subTotal-------------------',subTotal)
setFieldValue('tax', fixedTaxAmount);
    setFieldValue('grand_total', grandTotal);
  };
  
  // Update grand total whenever sub_total changes
  useEffect(() => {
    updateGrandTotal();
  }, [values.sub_total,productType,renderService]);

  const handleSwitchChange = (event) => {
    const includeTax = event.target.checked;
    let taxAmount = 0;
    if (includeTax) {
      taxAmount = values.sub_total * taxPercentage / 100;
    }
    const grandTotal = values.sub_total + taxAmount;
    setFieldValue('includeTax', includeTax ? 1 : 0);
    setFieldValue('tax', includeTax ? taxPercentage : 0);
    setFieldValue('grand_total', grandTotal);
  };

  const handleTaxCategoryChange = (newValue)=>{
    const taxAmount = newValue ? (newValue.type === 1 ? (values.sub_total * (newValue.value || 0) / 100) : (newValue.value || 0) ) : 0;
    let fixedAmount =parseFloat(taxAmount).toFixed(2)

    setFieldValue('tax', fixedAmount);
    let subTotal =parseFloat(values.sub_total).toFixed(2)
      
    // const grandTotal = Number(subTotal) + Number(fixedAmount)
    const grandTotal = (Number(subTotal) + Number(fixedAmount)).toFixed(2);
    setFieldValue('grand_total', grandTotal);
    console.log('dataaaaaaaaaaaaaaaaaaaaaaaaa',subTotal,fixedAmount,grandTotal)
  }


  const handleVendorChange = async (event, newValue) => {  
    if(newValue){
      setSelectedProducts([]);
      setFieldValue('products', []);
      setFieldValue('sub_total', 0);
      setFieldValue('grand_total', 0);
      setFieldValue('tax', 0);
      const selectedOption = vendors?.find(option => option.id === newValue.id)
      if(selectedOption){
      setFieldValue('vendor', newValue?.id);
      const newFilteredProductsOne = productsDatafilter.filter(product => {
        const vendorIds = product?.vendor_id?.split(',').map(id => id.trim()) || [];
        const secondaryVendorIds = product?.secondary_vendor_id?.split(',').map(id => id.trim()) || [];
        const vendorIdStr = newValue?.id?.toString();
        return vendorIds?.includes(vendorIdStr) || secondaryVendorIds?.includes(vendorIdStr);
      });
      const newFilteredProducts = newFilteredProductsOne?.filter(item=>item.inhouse == 1)
      console.log("Filtered Products:", newFilteredProducts);
      setProductsData(newFilteredProducts);

      }else {
      setFieldValue('vendor', '');
      }
  }
  else {
      setFieldValue('vendor', '')
  }
  };

  

  return (
    <Page title="Create Orders | Sign-Wise Solution">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <HeaderBreadcrumbs heading=" Create Orders" />  
          <Button
            variant="outlined"
            type="submit"
            onClick={() => handleback()}
            sx={{ alignItems: 'right' }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back
          </Button>
        </Stack>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={3} justifyContent="center" alignItems="center">
              <Grid item xs={12} md={11}>
                <Card sx={{ p: 8, margin: 'auto',height: 'fit-content' }}>
                  <Stack spacing={3}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <TextField
                            fullWidth
                            label="Name"
                            type="text"
                            {...getFieldProps('name')}
                            error={Boolean(touched.name && errors.name)}
                            helperText={touched.name && errors.name}
                        />
                        <Autocomplete
                            select
                            fullWidth
                            id="vendor"
                            options={vendors}
                            getOptionLabel={(option) => option.name}
                            value = {vendors?.find((option) => option.id === values.vendor) || null}
                            onChange={handleVendorChange}
                            renderOption={(props, option) => (
                              <li {...props}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  {option.syncWithQuickBook === 1 ? (
                                   <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                  ) : (
                                    <Avatar  sx={{ width: 30, height: 30, objectFit: "cover"}}/>
                                  )}
                                  <span>{option.name}</span>
                                </Box>
                              </li>
                            )}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select vendor"
                                fullWidth
                                SelectProps={{ native: true }}
                                error={Boolean(touched.vendor && errors.vendor)}
                                helperText={touched.vendor && errors.vendor}
                            />
                            )}
                        />
                    </Stack>
                    {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                    <TextField
                        fullWidth
                        label="Transaction ID"
                        {...getFieldProps('transactionId')}
                        error={Boolean(touched.transactionId && errors.transactionId)}
                        helperText={touched.transactionId && errors.transactionId}
                    />
                    </Stack> */}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <Box
                        component={MobileDatePicker}
                        label="Date Received"
                        maxDate={currentDate}
                        value={values.receivedDate}
                        onChange={(date) => setFieldValue('receivedDate', date)}
                        renderInput={(params) => (
                          <TextField size="medium" {...params} fullWidth />
                        )}
                      />
                      <Box
                        component={MobileDatePicker}
                        label="Date Expected"
                        minDate={currentDate}
                        value={values.expectedDate}
                        onChange={(date) => setFieldValue('expectedDate', date)}
                        renderInput={(params) => (
                          <TextField size="medium" {...params} fullWidth />
                        )}
                      />
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          value={values.orderType}
                          onChange={(event) => {
                            setFieldValue('orderType', event.target.value)
                            setFieldValue('sub_total', 0)
                            setFieldValue('tax', 0);
                            setSelectedTaxCategory(null);
                            setFieldValue('grand_total', 0);
                            setProductType(event.target.value)
                            if(event.target.value === 'materials'){
                              setFieldValue('stockCatalogs', []);
                              setSelectedStockCatalog([])
                              setFieldValue('services', []);
                              setSelectedServices([])
                            }else if(event.target.value === 'stockCatalog'){
                              setFieldValue('products', [])
                              setSelectedProducts([])
                              setFieldValue('services', []);
                              setSelectedServices([])
                            }else if(event.target.value === 'serviceOnly'){
                              setFieldValue('products', [])
                              setSelectedProducts([])
                              setFieldValue('stockCatalogs', []);
                              setSelectedStockCatalog([])
                            }
                          }}
                        >
                          <FormControlLabel
                            value="materials"
                            control={<Radio color="primary" />}
                            label="MATERIALS"
                          />
                          <FormControlLabel
                            value="stockCatalog"
                            control={<Radio color="primary" />}
                            label="STOCK CATALOGS"
                          />
                          <FormControlLabel
                            value="serviceOnly"
                            control={<Radio color="primary" />}
                            label="SERVICE ONLY"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Stack>
                    <Divider />
                    {
                      productType == "materials" && (
                        <>
                    <LabelStyleHead>Materials</LabelStyleHead>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      {                            console.log("values.products",values.products)}
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
                          <Autocomplete
                            fullWidth
                            multiple
                            id="combo-box-demo"
                            // options={productsData || []}
                            options={productsData?.filter(product => !selectedProducts.some(selected => selected.id === product.id)) || []}
                            value={values.products}
                            onChange={async (event, newValue) => {
                              if (!newValue || newValue.length === 0) {
                                setFieldValue('products', newValue);
                                setSelectedProducts([]);
                                setFieldValue('sub_total', 0);
                                setFieldValue('grand_total', 0);
                                setSearchMaterial('');
                                setQrSearchDisplayName('');
                              } else {
                                setFieldValue('products', newValue);
                                await handleProduct(newValue);
                              }
                            }}
                            // getOptionLabel={(option) => option.name ? option.name : ''}
                            // getOptionSelected={(option, value) => option.id === value.id}
                            // renderInput={(params) => (
                            //   <TextField {...params} required fullWidth
                            //   error={Boolean(touched.products && errors.products)}
                            //   helperText={touched.products && errors.products} 
                            //   label="Select material" />
                            // )}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => {
                              const name = option.name || '';
                              const description = option.description || '';
                              return `${description} \u200B${name}`.trim(); // combines both for search
                            }}
                            renderOption={(props, option) => {
                              const description = option.description || '';
                              return (
                                <li {...props}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {option.syncWithQuickbooks === 1 && (
                                      <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                    )}
                                    <Tooltip title={description}>
                                      <span style={{
                                        display: 'inline-block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '300px'
                                      }}>
                                        {description}
                                      </span>
                                    </Tooltip>
                                    <span style={{ display: 'none' }}>{option.name}</span>
                                  </Box>
                                </li>
                              );
                            }}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => {
                                const tooltipText = `${option.description || ''}`;
                                return (
                                  <Tooltip key={index} title={tooltipText}>
                                    <Chip
                                      {...getTagProps({ index })}
                                      label={option.description || ''}
                                    />
                                  </Tooltip>
                                );
                              })
                            }
                            filterOptions={(options, { inputValue }) =>
                              options.filter((option) => {
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(searchText) ||
                                  option.description?.toLowerCase().includes(searchText)
                                );
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                fullWidth
                                error={Boolean(touched.products && errors.products)}
                                helperText={touched.products && errors.products}
                                label="Select material"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      <Tooltip title="Scan QR Code">
                                        <IconButton
                                          size="small"
                                          onClick={() => setOpenQRScanner(true)}
                                          sx={{ mr: 1 }}
                                        >
                                          <QrCodeScanner />
                                        </IconButton>
                                      </Tooltip>
                                      {params.InputProps.endAdornment}
                                    </>
                                  )
                                }}
                              />
                            )}
                          />
                          <Dialog open={openQRScanner} onClose={() => setOpenQRScanner(false)}>
                            <DialogTitle>Scan QR Code</DialogTitle>
                            <DialogContent>
                              <div id="reader" style={{ width: "100%" }}></div>
                            </DialogContent>
                          </Dialog>
                        </Box>
                      </Stack>    
                      </>
                        )
                      }         
                      {(selectedProducts?.length > 0) &&
                      <>
                        <LabelStyle>Selected Materials</LabelStyle>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {VALUE?.map((val) => (
                                    <TableCell key={val.id}>{val.value}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedProducts?.map((data, index) => {
                                  const quantityFieldName = `quantity_${index}`;
                                  const unitCostFieldName = `unitCost_${index}`;
                                  const shippingFieldName = `shipping_cost_${index}`;
                                  // const rowTotal = calculateTotal(values[unitCostFieldName], values[quantityFieldName]);
                                  const rowTotal = (
                                  (parseFloat(data?.unitCost || 0) * parseFloat(data?.quantity || 0)) +
                                  (parseFloat(data?.shipping_cost || 0) * parseFloat(data?.quantity || 0)) +
                                  parseFloat(data?.services?.total_cost || 0)
                                ).toFixed(2);
                                  // Accumulate the totalAmount
                                  totalAmount += Number(rowTotal);
                                  const fixedTotal = parseFloat(totalAmount).toFixed(2);
                                  // setFieldValue('sub_total', fixedTotal);
                                  values['sub_total'] = fixedTotal
                                  console.log(data,'-----------data')
                                  return (
                                    <>
                                    <TableRow key={data.id}>
                                      <TableCell>{data.id}</TableCell>
                                      <TableCell>{data.name}</TableCell>                                 
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Unit Cost"
                                          sx={{width:"100px"}}
                                          value={data.unitCost || ''}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {

                                              if (newValue.includes('.')) {
                                                const parts = newValue.split('.');
                                                if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                }
                                            }

                                              data['unitCost'] = newValue || 0;
                                              setFieldValue(unitCostFieldName, newValue);
                                            }
                                          
                                          }}
                                          error={Boolean(touched[unitCostFieldName] && errors[unitCostFieldName])}
                                          helperText={touched[unitCostFieldName] && errors[unitCostFieldName]}
                                        />
                                      </TableCell>
                                        <TableCell align='center'>{data.total_qty}</TableCell> 
                                        <TableCell align='center'>{data.min_value}</TableCell> 
                                        <TableCell align='center'>{data.max_value}</TableCell> 
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Quantity"
                                          // value={Number(data.quantity)}
                                          value={data.quantity || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '.' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              // if (newValue === '' || newValue <= 0) {
                                              //   event.preventDefault();
                                              //   return;
                                              // }
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              data['quantity'] = newValue || 0;
                                              setFieldValue(quantityFieldName, newValue);
                                            }
                                          }}
                                          error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                      </TableCell>
                                      {/* <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Shipping"
                                          value={data?.shipping_cost || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              data['shipping_cost'] = newValue || 0;
                                              setFieldValue(shippingFieldName, newValue);
                                            }
                                          }}
                                          error={Boolean(touched[shippingFieldName] && errors[shippingFieldName])}
                                          helperText={touched[shippingFieldName] && errors[shippingFieldName]}
                                        />
                                      </TableCell> */}
                                      <TableCell> 
                                        {rowTotal}
                                        {/* {calculateTotal(values[unitCostFieldName], values[quantityFieldName])} */}
                                      </TableCell>
                                      <TableCell >
                                        <IconButton onClick={() => handleDeleteProduct(data.id,1)}>
                                          <Delete />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow key={`sub-material-${data.id}`}>
                                        <TableCell colSpan={3}>
                                          <Autocomplete
                                            fullWidth
                                            id={`sub-material-autocomplete-${data.id}`}
                                            options={serviceData}
                                            value={data.services || null}
                                            onChange={(e, newValue) => {
                                            const updatedProducts = [...selectedProducts];
                                            updatedProducts[index].services = newValue;
                                            setSelectedProducts(updatedProducts);
                                            setRenderService(!renderService)
                                          }}
                                            getOptionLabel={(option) => `${option.description || ''} ${option.name || ''}`.trim()}
                                            renderOption={(props, option) => (
                                              <li {...props}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  {option.syncWithQuickbooks == 1 && (
                                                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                                  )}
                                                  <span>{`${option.description || ''} ${option.name || ''}`.trim()}</span>
                                                </Box>
                                              </li>
                                            )}
                                            renderInput={(params) => (
                                              <TextField {...params} label="Select Service (optional)" required fullWidth />
                                            )}
                                          />
                                        </TableCell>
                                        <TableCell colSpan={4}>
                                          {data.services ? (
                                            <TextField
                                              fullWidth
                                              type='number'
                                              label="Service Cost"
                                              value={data.services.total_cost || ''}
                                              onWheel={(e) => e.target.blur()}
                                              onKeyPress={(event) => {
                                                if (event.key === '0' && event.target.value === '0') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '0' && event.target.value === '') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              
                                            onKeyDown={(event) => {
                                              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                const newValue = event.target.value || 0;
                                                if (newValue < 1 && event.key === 'ArrowDown') {
                                                  event.preventDefault(); 
                                                }
                                              }
                                            }}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                if (newValue === "" || newValue === "0") {
                                                  newValue = "0";
                                                } else {
                                                  if (newValue.includes('.')) {
                                                    const parts = newValue.split('.');
                                                    if (parts[1].length > 2) {
                                                      newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                    }
                                                  }
                                                }
                                                const updatedProducts = [...selectedProducts];
                                                if (updatedProducts[index].services) {
                                                  updatedProducts[index].services.total_cost = newValue || 0;
                                                }
                                                setSelectedProducts(updatedProducts);
                                                
                                                // Recalculate sub_total
                                                let newTotalAmount = 0;
                                                updatedProducts.forEach(product => {
                                                  const subtotal = (
                                                    (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                    (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                    parseFloat(product?.services?.total_cost || 0)
                                                  );
                                                  newTotalAmount += subtotal;
                                                });
                                                const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                                setFieldValue('sub_total', Number(fixedTotal));
                                              }}
                                            />
                                          ) : (
                                            <Typography variant='body1'>No service selected</Typography>
                                          )}
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell colSpan={11} sx={{ padding: 0 }}>
                                          <Divider />
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </>}

                {
                  productType == "stockCatalog" && (
                    <>

                      <LabelStyleHead>Stock Catalogs</LabelStyleHead>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
                          <Autocomplete
                            fullWidth
                            multiple
                            id="combo-box-demo"
                            options={stockCatalogs?.filter(product => !selectedStockCatalog.some(selected => selected.id === product.id)) || []}
                            value={values.stockCatalogs}
                            onChange={async (event, newValue) => {
                              if (!newValue || newValue.length === 0) {
                                setFieldValue('stockCatalogs', newValue);
                                setSelectedStockCatalog([]);
                                setFieldValue('sub_total', 0);
                                setFieldValue('grand_total', 0);
                                setSearchCatalog('');
                                setQrCatalogSearchDisplayName('');
                              } else {
                                setFieldValue('stockCatalogs', newValue);
                                await handleStockCatalog(newValue);
                              }
                            }}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => {
                              const name = option.name || '';
                              const description = option.description || '';
                              return `${description} \u200B${name}`.trim(); // combines both for search
                            }}
                            renderOption={(props, option) => {
                              const description = option.description || '';
                              return (
                                <li {...props}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {option.syncWithQuickbooks === 1 && (
                                      <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                    ) }
                                    <Tooltip title={description}>
                                      <span style={{
                                        display: 'inline-block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '300px'
                                      }}>
                                        {description}
                                      </span>
                                    </Tooltip>
                                    <span style={{ display: 'none' }}>{option.name}</span>
                                  </Box>
                                </li>
                              );
                            }}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => {
                                const tooltipText = `${option.description || ''}`;
                                return (
                                  <Tooltip key={index} title={tooltipText}>
                                    <Chip
                                      {...getTagProps({ index })}
                                      label={option.description || ''}
                                    />
                                  </Tooltip>
                                );
                              })
                            }
                            filterOptions={(options, { inputValue }) =>
                              options.filter((option) => {
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(searchText) ||
                                  option.description?.toLowerCase().includes(searchText)
                                );
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                fullWidth
                                error={Boolean(touched.stockCatalogs && errors.stockCatalogs)}
                                helperText={touched.stockCatalogs && errors.stockCatalogs}
                                label="Select Catalog"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      <Tooltip title="Scan QR Code">
                                        <IconButton
                                          size="small"
                                          onClick={() => setOpenCatalogQRScanner(true)}
                                          sx={{ mr: 1 }}
                                        >
                                          <QrCodeScanner />
                                        </IconButton>
                                      </Tooltip>
                                      {params.InputProps.endAdornment}
                                    </>
                                  )
                                }}
                              />
                            )}
                          />
                          <Dialog open={openCatalogQRScanner} onClose={() => setOpenCatalogQRScanner(false)}>
                            <DialogTitle>Scan QR Code</DialogTitle>
                            <DialogContent>
                              <div id="reader" style={{ width: "100%" }}></div>
                            </DialogContent>
                          </Dialog>
                        </Box>
                      </Stack>
                      </>
                    )
                     }

                      {(selectedStockCatalog?.length > 0) &&
                      <>
                        <LabelStyle>Selected Catalogs</LabelStyle>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {VALUEStockCatalog?.map((val) => (
                                    <TableCell key={val.id}>{val.value}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedStockCatalog?.map((data, index) => {
                                  const quantityFieldName = `quantity_${index}`;
                                  const unitCostFieldName = `unitCost_${index}`;
                                  const shippingFieldName = `shipping_cost_${index}`;
                                  const rowTotal = (
                                  (parseFloat(data?.unitCost || 0) * parseFloat(data?.quantity || 0)) +
                                  (parseFloat(data?.shipping_cost || 0) * parseFloat(data?.quantity || 0)) +
                                  parseFloat(data?.services?.total_cost || 0)
                                ).toFixed(2);
                                  // Accumulate the totalAmount
                                  totalAmount += Number(rowTotal);
                                  const fixedTotal = parseFloat(totalAmount).toFixed(2);
                                  // setFieldValue('sub_total', fixedTotal);
                                  values['sub_total'] = fixedTotal
                                  console.log(data,'-----------data')
                                  return (
                                    <>
                                    <TableRow key={data.id}>
                                      <TableCell>{data.id}</TableCell>
                                      <TableCell>{data.name}</TableCell>                                 
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Unit Cost"
                                          sx={{width:"100px"}}
                                          value={data.unitCost || ''}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {

                                              if (newValue.includes('.')) {
                                                const parts = newValue.split('.');
                                                if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                }
                                            }

                                              data['unitCost'] = newValue || 0;
                                              setFieldValue(unitCostFieldName, newValue);
                                            }
                                          
                                          }}
                                          error={Boolean(touched[unitCostFieldName] && errors[unitCostFieldName])}
                                          helperText={touched[unitCostFieldName] && errors[unitCostFieldName]}
                                        />
                                      </TableCell>
                                        <TableCell align='center'>{data.total_qty}</TableCell>  
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Quantity"
                                          value={data.quantity || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '.' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              data['quantity'] = newValue || 0;
                                              setFieldValue(quantityFieldName, newValue);
                                            }
                                          }}
                                          error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                      </TableCell>
                                      {/* <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Shipping"
                                          value={data?.shipping_cost || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              data['shipping_cost'] = newValue || 0;
                                              setFieldValue(shippingFieldName, newValue);
                                            }
                                          }}
                                          error={Boolean(touched[shippingFieldName] && errors[shippingFieldName])}
                                          helperText={touched[shippingFieldName] && errors[shippingFieldName]}
                                        />
                                      </TableCell> */}
                                      <TableCell> 
                                        {rowTotal}
                                      </TableCell>
                                      <TableCell >
                                        <IconButton onClick={() => handleDeleteProduct(data.id,0)}>
                                          <Delete />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow key={`sub-catalog-${data.id}`}>
                                        <TableCell colSpan={3}>
                                          <Autocomplete
                                            fullWidth
                                            id={`sub-catalog-autocomplete-${data.id}`}
                                            options={serviceData}
                                            value={data.services || null}
                                            onChange={(e, newValue) => {
                                            const updatedProducts = [...selectedStockCatalog];
                                            updatedProducts[index].services = newValue;
                                            setSelectedStockCatalog(updatedProducts);
                                            setRenderService(!renderService)
                                          }}
                                            getOptionLabel={(option) => `${option.description || ''} ${option.name || ''}`.trim()}
                                            renderOption={(props, option) => (
                                              <li {...props}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  {option.syncWithQuickbooks == 1 && (
                                                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                                  )}
                                                  <span>{`${option.description || ''} ${option.name || ''}`.trim()}</span>
                                                </Box>
                                              </li>
                                            )}
                                            renderInput={(params) => (
                                              <TextField {...params} label="Select Service (optional)" required fullWidth />
                                            )}
                                          />
                                        </TableCell>
                                        <TableCell colSpan={4}>
                                          {data.services ? (
                                            <TextField
                                              sx={{width:"200px"}}
                                              type='number'
                                              label="Service Cost"
                                              value={data.services.total_cost || ''}
                                              onWheel={(e) => e.target.blur()}
                                              onKeyPress={(event) => {
                                                if (event.key === '0' && event.target.value === '0') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '0' && event.target.value === '') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              
                                            onKeyDown={(event) => {
                                              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                const newValue = event.target.value || 0;
                                                if (newValue < 1 && event.key === 'ArrowDown') {
                                                  event.preventDefault(); 
                                                }
                                              }
                                            }}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                if (newValue === "" || newValue === "0") {
                                                  newValue = "0";
                                                } else {
                                                  if (newValue.includes('.')) {
                                                    const parts = newValue.split('.');
                                                    if (parts[1].length > 2) {
                                                      newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                    }
                                                  }
                                                }
                                                const updatedCatalogs = [...selectedStockCatalog];
                                                if (updatedCatalogs[index].services) {
                                                  updatedCatalogs[index].services.total_cost = newValue || 0;
                                                }
                                                setSelectedStockCatalog(updatedCatalogs);
                                                
                                                // Recalculate sub_total
                                                let newTotalAmount = 0;
                                                updatedCatalogs.forEach(catalog => {
                                                  const subtotal = (
                                                    (parseFloat(catalog?.unitCost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                    (parseFloat(catalog?.shipping_cost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                    parseFloat(catalog?.services?.total_cost || 0)
                                                  );
                                                  newTotalAmount += subtotal;
                                                });
                                                const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                                setFieldValue('sub_total', Number(fixedTotal));
                                              }}
                                            />
                                          ) : (
                                            <Typography variant='body1'>No service selected</Typography>
                                          )}
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell colSpan={11} sx={{ padding: 0 }}>
                                          <Divider />
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </>}

                      {
                        productType == "serviceOnly" && (
                          <>
                            <LabelStyleHead>Services</LabelStyleHead>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
                                <Autocomplete
                                  fullWidth
                                  multiple
                                  id="service-autocomplete"
                                  options={serviceData?.filter(service => !selectedServices.some(selected => selected.id === service.id)) || []}
                                  value={values.services}
                                  onChange={(event, newValue) => {
                                    if (!newValue || newValue.length === 0) {
                                      setFieldValue('services', newValue);
                                      setSelectedServices([]);
                                      setFieldValue('sub_total', 0);
                                      setFieldValue('grand_total', 0);
                                    } else {
                                      setFieldValue('services', newValue);
                                      handleService(newValue);
                                    }
                                  }}
                                  isOptionEqualToValue={(option, value) => option.id === value.id}
                                  getOptionLabel={(option) => `${option.description || ''} ${option.name || ''}`.trim()}
                                  renderOption={(props, option) => (
                                    <li {...props}>
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        {option.syncWithQuickbooks == 1 && (
                                          <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                        )}
                                        <span>{`${option.description || ''} ${option.name || ''}`.trim()}</span>
                                      </Box>
                                    </li>
                                  )}
                                  renderTags={(value, getTagProps) =>
                                    value.map((option, index) => {
                                      const tooltipText = `${option.description || ''} ${option.name || ''}`.trim();
                                      return (
                                        <Tooltip key={index} title={tooltipText}>
                                          <Chip
                                            {...getTagProps({ index })}
                                            label={`${option.description || ''} ${option.name || ''}`.trim()}
                                          />
                                        </Tooltip>
                                      );
                                    })
                                  }
                                  filterOptions={(options, { inputValue }) =>
                                    options.filter((option) => {
                                      const searchText = inputValue.toLowerCase();
                                      return (
                                        option.name?.toLowerCase().includes(searchText) ||
                                        option.description?.toLowerCase().includes(searchText)
                                      );
                                    })
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      required
                                      fullWidth
                                      error={Boolean(touched.services && errors.services)}
                                      helperText={touched.services && errors.services}
                                      label="Select Services"
                                    />
                                  )}
                                />
                              </Box>
                            </Stack>
                          </>
                        )
                      }

                      {(selectedServices?.length > 0) &&
                      <>
                        <LabelStyle>Selected Services</LabelStyle>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Service ID</TableCell>
                                  <TableCell>Service Name</TableCell>
                                  <TableCell>Price</TableCell>
                                  <TableCell></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedServices?.map((data, index) => {
                                  const priceFieldName = `service_price_${index}`;
                                  return (
                                    <>
                                      <TableRow key={data.id}>
                                        <TableCell>{data.id}</TableCell>
                                        <TableCell>{data.description || data.name}</TableCell>
                                        <TableCell>
                                          <TextField
                                            required
                                            fullWidth
                                            type='number'
                                            label="Price"
                                            sx={{width:"200px"}}
                                            value={data.total_cost || ''}
                                            onWheel={(e) => e.target.blur()}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '0') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '-') {
                                                event.preventDefault();
                                              }
                                            }}
                                            onKeyDown={(event) => {
                                              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                const newValue = event.target.value || 0;
                                                if (newValue < 1 && event.key === 'ArrowDown') {
                                                  event.preventDefault(); 
                                                }
                                              }
                                            }}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              if (newValue === "" || newValue === "0") {
                                                newValue = "0";
                                              } else {
                                                if (newValue.includes('.')) {
                                                  const parts = newValue.split('.');
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                  }
                                                }
                                              }
                                              const updatedServices = [...selectedServices];
                                              updatedServices[index].total_cost = newValue || 0;
                                              setSelectedServices(updatedServices);
                                              
                                              // Recalculate sub_total
                                              let newTotalAmount = 0;
                                              updatedServices.forEach(service => {
                                                newTotalAmount += parseFloat(service?.total_cost || 0);
                                              });
                                              const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                              setFieldValue('sub_total', Number(fixedTotal));
                                            }}
                                            error={Boolean(touched[priceFieldName] && errors[priceFieldName])}
                                            helperText={touched[priceFieldName] && errors[priceFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <IconButton onClick={() => handleDeleteProduct(data.id, 2)}>
                                            <Delete />
                                          </IconButton>
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell colSpan={4} sx={{ padding: 0 }}>
                                          <Divider />
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </>}

                     
                      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
                        

                          <Autocomplete
                              // sx={{ width: 400 }}
                              fullWidth
                              id="combo-box-demo"
                              options={taxCategories || []}
                              value={selectedTaxCategory || null}
                              onChange={(event, newValue) => {
                                handleTaxCategoryChange(newValue)
                                setSelectedTaxCategory(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Select tax category" />
                              )}
                              getOptionLabel={(option) => option.name ? option.name : ''}
                            />
                      </Box>

                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <TextField
                          fullWidth
                          label="Sub Total"
                          {...getFieldProps('sub_total')}
                          error={Boolean(touched.sub_total && errors.sub_total)}
                          helperText={touched.sub_total && errors.sub_total}
                          InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                          InputProps={{ readOnly:true }}
                        />
                        <TextField
                          fullWidth
                          label="Tax"
                          {...getFieldProps('tax')}
                          error={Boolean(touched.tax && errors.tax)}
                          helperText={touched.tax && errors.tax}
                          InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                          InputProps={{ readOnly:true }}
                        />
                        <TextField
                          fullWidth
                          label="Grand Total"
                          {...getFieldProps('grand_total')}
                          error={Boolean(touched.grand_total && errors.grand_total)}
                          helperText={touched.grand_total && errors.grand_total}
                          InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                          InputProps={{ readOnly:true }}
                        />
                      </Stack>

                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                      <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                        Create Order
                      </LoadingButton>
                      <Button variant="outlined" onClick={()=>{handleback()}} sx={{ marginLeft: '10px' }}>
                        Cancel
                      </Button>
                    </Box>
                  </Stack>
                </Card>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </Container>
    </Page>
  );
}